import { TestDecryptionResultResponse } from "@admin_api/models/test-decryption-result-response";
import { GoogleCertificationService } from "@admin_api/services/google-certification.service";
import { Component } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";



@Component({
    selector: "app-google-pay-certificate",
    templateUrl: "./google-pay-certificate.component.html",
    styleUrls: ["./google-pay-certificate.component.less"],
    standalone: false
})
export class GooglePayCertificateComponent {

    constructor(
        private fb: UntypedFormBuilder,
        private googleCertificationService: GoogleCertificationService,
    ) {}

    response: TestDecryptionResultResponse | null = null;

    certificateForm = this.fb.group({
        token: [null, [Validators.required]],
        gatewayMerchantId: [null, [Validators.required]],
        body: [null, [Validators.required]],
    });

    async onSubmit() {

        this.response = await this.googleCertificationService.googleCertificationCheckPayload(
            this.certificateForm.value,
        ).toPromise();
    }
}
